<template>
    <div class="card buildingCard">
        <div class="card-body buildingCard-body" v-bind:data-building-id="buildingProcessedId">
            <slot name="title"></slot>
            <form v-on:submit.prevent>
                <dl class="card-text clearfix buildingCard-list">
                    <dt>
                        AFSS Deadline:
                        <ToolTip>
                            <sup class="superScript">
                                <i class="fas fa-info-circle"
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   data-html="true"
                                   title=""
                                   data-original-title='The date you must submit the certificate'
                                ></i>
                            </sup>
                        </ToolTip>
                    </dt>
                    <dd>
                    <div class="input-group date"
                             data-provide="datepicker"
                             data-date-format="dd/mm/yyyy"
                             data-date-week-start="0"
                             v-bind:data-date="deadLineString"
                             v-bind:data-date-start-date="dateRange.start_date"
                             v-bind:data-date-end-date="dateRange.end_date"
                             data-date-multidate="false"
                             data-date-calendar-weeks="true"
                             data-date-today-highlight="false">
                            <input type="text" class="form-control bg-white" readonly
                                   v-bind:class="{ 'is-invalid': failedValidation.deadLine }"
                                   v-bind:value="deadLineString">
                            <div class="input-group-addon">
                                <span class="glyphicon glyphicon-th"></span>
                            </div>
                            <div class="invalid-feedback" v-if="msgValidation.deadLine">{{msgValidation.deadLine}}</div>
                        </div>
                    </dd>
                    <dt>
                        Test Start Lead Time:
                        <ToolTip>
                            <sup class="superScript">
                                <i class="fas fa-info-circle"
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   data-html="true"
                                   title=""
                                   data-original-title='Preferred number of days before the AFSS deadline that the test should first run'
                                ></i>
                            </sup>
                        </ToolTip>
                    </dt>
                    <dd>
                        <input type="text" maxlength="3" style="display: inline-block; width: 80px;" class="form-control" v-bind:class="{ 'is-invalid': failedValidation.leadTime }" v-model="leadTimeString"/>
                        <span> days{{calculatedStartDate && `, so the annual test will start on ${tools.formatDateWithOutYear(calculatedStartDate, building_time_zone)}`}}</span>
                        <div class="invalid-feedback" v-if="msgValidation.leadTime">{{msgValidation.leadTime}}</div>
                    </dd>
                    <dt>
                        Test Start Time:
                        <ToolTip>
                            <sup class="superScript">
                                <i class="fas fa-info-circle"
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   data-html="true"
                                   title=""
                                   data-original-title='Preferred time of day that the test should run'
                                ></i>
                            </sup>
                        </ToolTip>
                    </dt>
                    <dd>
                        <select class="form-control" v-model="selected">
                            <option v-for="time in timeRange" v-bind:value="time.value">{{time.text}}</option>
                        </select>
                    </dd>
                </dl>

                <div class="clearfix"></div>

                <button v-if="exist_dead" type="button" class="btn btn-link float-left buildingCard-body-btn btn-sm"
                        v-on:click.prevent="$emit('showFormCard', false)">
                    Cancel
                </button>

                <button v-if="!exist_dead" type="button" class="btn btn-primary float-right buildingCard-body-btn btn-sm"
                        @click="add()">
                    Add AFSS Deadline
                </button>

                <button v-if="exist_dead" type="button" class="btn btn-primary float-right buildingCard-body-btn btn-sm"
                        @click="confirmPopup('Update Afss',buildingProcessedId)">
                    Update
                </button>

                <div class="clearfix"></div>
                <div class="card-text" v-if="msgValidation.message">
                    <hr>
                    <div class="alert alert-danger m-0" role="alert">{{msgValidation.message}}</div>
                </div>
            </form>
        </div>
        <UpdateAfssModalComponent
                v-if="dataToPassToModal.showModal"
                @updateBuildingTest="update()"
                @cancelModal="cancelModal()"
                :confirm="confirm"
        >
        </UpdateAfssModalComponent>
    </div>
</template>
<script>
import UpdateAfssModalComponent from '@/components/modal/UpdateAfssModalComponent.vue'
import Tools from "@/app-model/tools";
import ToolTip from '@/components/tool-tip/ToolTip.vue'

export default {
    props: {
      report_type: String,
      lead_time: Number,
      dead_line: Number,
      building_id: Number,
      building_time_zone: String,
      exist_dead: Boolean,
    },
    data () {
      return {
        dataToPassToModal: {
          showModal: false,
        },
        showUpdateModal: false,
        leadTimeString: '',
        deadLineString: '',
        selected: 0,
        times: {},
        reportType: '',
        deadLine: 0,
        failedValidation: {
          reportType: false,
          leadTime: false,
          deadLine: false,
        },
        msgValidation: {
          reportType: undefined,
          leadTime: undefined,
          deadLine: undefined,
          message: undefined,
        },
        filedMapping: {
          report_type: 'reportType',
          lead_time: 'leadTime',
          dead_line: 'deadLine',
          message: 'message',
        },
      }
    },
    components: {
      UpdateAfssModalComponent,
      ToolTip,
    },
    computed: {
      tools: function () {
        return new Tools
      },
      datepicker: function () {
        return jQuery(this.$el).find('[data-provide="datepicker"]')
      },
      buildingProcessedId: function () {
        this.resetData()
        return this.building_id
      },
      timeRange: function () {
        let hour = 0
        this.times = []
        for (let tmpHour of [' am', ' pm']) {
          for (let n = 0; n < 12; n++) {
            this.times[hour] = {
              text: (n ? n : 12) + tmpHour,
              value: hour
            }
            hour++
          }
        }

        return this.times
      },
      dateRange: function () {
        let start = new Date(0)
        let now = new Date()
        let end = new Date(0)

        start.setFullYear(now.getFullYear(), now.getMonth(), now.getDate())
        start.setDate(start.getDate() + 4) //testing length + lock down
        end.setFullYear(start.getFullYear())
        end.setMonth(start.getMonth() + 12)

        if (this.dead_line) {
          end.setDate(start.getDate()-3)
        }
        else {
          end.setDate(start.getDate() - 4)
        }

        end.setHours(24)
        end.setSeconds(end.getSeconds() - 1)

        return {
          start_date: `${start.getDate()}/${start.getMonth() + 1}/${start.getFullYear()}`,
          end_date: `${end.getDate()}/${end.getMonth() + 1}/${end.getFullYear()}`,
          start: start,
          end: end,
        }
      },
      leadTime: function() {
        const leadTimeInt = parseInt(this.leadTimeString);
        return isNaN(leadTimeInt) ? 0 : leadTimeInt;
      },
      calculatedStartDate: function() {
        if (this.leadTime === 0 || this.deadLine === 0) {
          return null;
        }
        const leadTimeMillis = this.leadTime * 24 * 60 * 60 * 1000;
        // Deadline is always midnight - add 3 hours to avoid daylight savings making us skip a day
        const startDateMillis = this.deadLine + (3 * 60 * 60 * 1000) - leadTimeMillis;

        return new Date(startDateMillis);
      },
    },
    mounted () {
      let self = this

      this.leadTimeString = this.lead_time == null ? '' : this.lead_time.toString();
      this.setDeadLine()

      this.datepicker.on('changeDate', function (e) {
        e.date.setDate(e.date.getDate() + 1)
        e.date.setSeconds(e.date.getSeconds() - 1)
        self.deadLine = e.date.getTime()
        self.deadLineString = e.date.toLocaleDateString('en-AU')
      })
    },
    methods: {
      confirmPopup: function () {
        this.confirm = {
          title: 'Are you sure?',
          msg: 'This will reschedule all existing tests that haven\'t started yet',
        }
        this.dataToPassToModal.showModal = true
      },

      resetData () {
        this.reportType = this.report_type
        this.selected = this.dead_line ? (new Date(this.dead_line * 1000)).getHours() : 0
        this.setDeadLine()
      },
      setDeadLine () {
        this.deadLine = ''
        this.deadLineString = ''
        if (this.dead_line !== undefined) {
          let tmp = new Date(this.dead_line * 1000),
            deadLine = new Date(0)

          deadLine.setFullYear(tmp.getFullYear(), tmp.getMonth(), tmp.getDate())
          deadLine.setHours(0)

          this.deadLine = deadLine.getTime()

          this.deadLineString = deadLine.toLocaleDateString('en-AU')
        }
      },
      add () {
        this.formValidation()
        return this.$store.dispatch(
          'apiResult',
          {
            method: 'patch',
            path: `api/user-buildings/${this.buildingProcessedId}/afss`,
            path_template: `/api/user-buildings/{building_id}/afss`,
            building_id: this.buildingProcessedId,
            data: {
              lead_time: parseInt(this.leadTimeString),
              dead_line: Math.round(this.deadLine / 1000),
              report_type: this.reportType,
              time: this.selected
            },
          }
        ).then(response => {
          switch (response.status) {
            case 200:
              this.$emit('showFormCard', false)
              this.$emit('reFetch')
              this.$emit('reFetchScheduledTests')
              break
            case 422:
              for (let i in response.data) {
                let field = this.filedMapping[i]
                if (field !== undefined) {
                  this.msgValidation[field] = response.data[i].join(', ')
                }
              }
              break
          }
        })
      },
      update () {
        this.formValidation()
        return this.$store.dispatch(
          'apiResult',
          {
            method: 'PATCH',
            path: `api/user-buildings/${this.buildingProcessedId}/afss`,
            path_template: `/api/user-buildings/{building_id}/afss`,
            building_id: this.buildingProcessedId,
            data: {
              lead_time: parseInt(this.leadTimeString),
              dead_line: Math.round(this.deadLine / 1000),
              report_type: this.reportType,
              time: this.selected
            },
          }
        ).then(response => {
          switch (response.status) {
            case 200:
              this.$emit('showFormCard', false)
              this.$emit('reFetch')
              this.$emit('reFetchScheduledTests')
              break
            case 422:
              for (let i in response.data) {
                let field = this.filedMapping[i]
                if (field !== undefined) {
                  this.msgValidation[field] = response.data[i].join(', ')
                }
              }
              this.cancelModal()
              break
          }
        })
      },

      formValidation () {
        let promise

        let valid = true

        const leadTime = parseInt(this.leadTimeString)
        this.failedValidation.leadTime = isNaN(leadTime) || leadTime < 5 || leadTime > 120
        this.failedValidation.deadLine = !(this.dateRange.start.getTime() <= this.deadLine && this.deadLine <= this.dateRange.end.getTime())

        for (let i in this.msgValidation) {
          this.msgValidation[i] = undefined
        }

        for (let i in this.failedValidation) {
          valid = valid && !this.failedValidation[i]
        }

        if (!valid) {
          return
        }
      },
      cancelModal () {
        this.dataToPassToModal.showModal = false
      }
    }
  }

</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>